import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { githubPullRequestsPlugin as legacyGithubPullRequestsPlugin } from '@roadiehq/backstage-plugin-github-pull-requests';
import {
  githubPullRequestsApi,
  githubPullRequestsEntityContent,
} from './GithubPullRequestsExtensions';

/**
 * New-frontend-system wrapper around the (legacy-only) Roadie GitHub Pull
 * Requests plugin. The GitHub Actions (CI/CD) plugin needs no wrapper — it
 * ships an `/alpha` frontend plugin that `app.packages: all` auto-discovers.
 */
export const githubPullRequestsPlugin = createFrontendPlugin({
  pluginId: 'github-pull-requests',
  routes: convertLegacyRouteRefs(legacyGithubPullRequestsPlugin.routes),
  extensions: [githubPullRequestsApi, githubPullRequestsEntityContent],
});
